export const isStudentOptions = (t) => [
  { label: t('isStudent'), value: 0 },
  { label: t('isParent'), value: 1 },
];

export const genderOptions = (t) => [
  { label: t('male'), value: 1 },
  { label: t('female'), value: 2 },
];

export const genderStudentOptions = (t) => [
  { label: t('maleStudent'), value: 1 },
  { label: t('femaleStudent'), value: 2 },
];

export const genderNAOptions = (t) => [
  { label: t('maleStudent'), value: 1 },
  { label: t('femaleStudent'), value: 2 },
  { label: t('noGender'), value: 0 },
];

export const languageOptions = (t) => [
  { label: t('korean'), value: 1 },
  { label: t('english'), value: 0 },
];

export const urgentOptions = (t) => [
  { label: t('urgent'), value: 1 },
  { label: t('considering'), value: 0 },
];

export const urgent3Options = (t) => [
  { label: t('isUrgent'), value: 1 },
  { label: t('isInterested'), value: 0 },
  { label: t('isNotInterested'), value: 2 },
];

export const demoOptions = (t) => [
  { label: t('yesDemo'), value: 1 },
  { label: t('noDemo'), value: 0 },
];

export const gradeOptions = (t) => [
  { label: t('7th'), value: 0 },
  { label: t('repeater'), value: 6 },
  { label: t('8th'), value: 1 },
  { label: t('undergraduate'), value: 7 },
  { label: t('9th'), value: 2 },
  { label: t('graduate'), value: 8 },
  { label: t('10th'), value: 3 },
  { label: t('jobSeeker'), value: 9 },
  { label: t('11th'), value: 4 },
  { label: t('worker'), value: 10 },
  { label: t('12th'), value: 5 },
  { label: t('others'), value: 11 },
];

export const gradeOptionsOrdered = (t) =>
  gradeOptions(t).sort((a, b) => (a.value > b.value ? 1 : -1));

export const offlineOptions = (t) => [
  { label: t('online'), value: 0 },
  { label: t('offline'), value: 1 },
];

export const feeOptions = (t) => [
  { value: 10000, label: `${'10,000'} ${t('orAbove')}` },
  { value: 20000, label: `${'20,000'} ${t('orAbove')}` },
  { value: 30000, label: `${'30,000'} ${t('orAbove')}` },
  { value: 40000, label: `${'40,000'} ${t('orAbove')}` },
  { value: 50000, label: `${'50,000'} ${t('orAbove')}` },
  { value: 60000, label: `${'60,000'} ${t('orAbove')}` },
  { value: 70000, label: `${'70,000'} ${t('orAbove')}` },
  { value: 80000, label: `${'80,000'} ${t('orAbove')}` },
  { value: 90000, label: `${'80,000'} ${t('above')}` },
];

export const feeMaxOptions = (t) => [
  { value: 10000, label: `${'10,000'} ${t('orBelow')}` },
  { value: 20000, label: `${'20,000'} ${t('orBelow')}` },
  { value: 30000, label: `${'30,000'} ${t('orBelow')}` },
  { value: 40000, label: `${'40,000'} ${t('orBelow')}` },
  { value: 50000, label: `${'50,000'} ${t('orBelow')}` },
  { value: 60000, label: `${'60,000'} ${t('orBelow')}` },
  { value: 70000, label: `${'70,000'} ${t('orBelow')}` },
  { value: 80000, label: `${'80,000'} ${t('orBelow')}` },
];

export const idTypeOptions = (t) => [
  { value: 0, label: t('idNumber'), default: true },
  { value: 1, label: t('alienNumber') },
];

export const howOptions = (t) => [
  { value: '지인소개', label: t('throughFriend') },
  { value: '네이버 광고', label: t('throughNaver') },
  { value: '설명회', label: t('throughEvent') },
  { value: '기타', label: t('etc') },
];

export const userTypeOptions = (t) => [
  { label: t('studentRegister'), value: 'student' },
  { label: t('tutorRegister'), value: 'tutor' },
];

export const whyExitOptions = (t) => [
  { value: '홍보 연락을 너무 많이 받고 있습니다', label: t('notifyLotOfAds') },
  {
    value: '모르는 사람의 연락을 받고 싶지 않습니다',
    label: t('doNotWantReceiveMessage'),
  },
  {
    value: '개인 정보를 노출하고 싶지 않습니다',
    label: t('doNotWantAppearPersonalInfo'),
  },
  { value: '매칭이 되지 않습니다', label: t('doNotMatched') },
  { value: '사용 빈도가 낮습니다', label: t('lowUsing') },
  { value: '기타 사유', label: t('etc') },
];

export const discussionCategoryoptions = (t) => [
  { label: t('question'), value: 0 },
  { label: t('column'), value: 1 },
];

export const discussionSortingOptions = (t) => [
  { label: t('sortByRecent'), value: '', default: true },
  { label: t('sortByview'), value: 'views' },
  { label: t('sortByComment'), value: 'comments' },
];

export const discussionCategoryMap = (t) => ({
  0: t('question'),
  1: t('column'),
});

export const degreeTypeOptions = (t) => [
  { label: t('bachelor'), value: 1 },
  { label: t('master'), value: 2 },
  { label: t('phd'), value: 3 },
];

export const degreeTypeMap = (t) => ({
  1: t('bachelor', { ns: 'common' }),
  2: t('master', { ns: 'common' }),
  3: t('phd', { ns: 'common' }),
});

export const isGraduatedOptions = (t) => [
  { label: t('attending'), value: 0 },
  { label: t('graduated'), value: 1 },
];

export const reportingOptions = (t) => [
  { label: t('reportBully'), value: 1 },
  { label: t('reportCopyright'), value: 2 },
  { label: t('reportThreat'), value: 3 },
  { label: t('reportHatred'), value: 4 },
  { label: t('reportSpam'), value: 5 },
];
